import { Injectable } from '@angular/core';
import { Converter } from '@spartacus/core';

@Injectable({ providedIn: 'root' })
export class KbCatgegoryUrlNormalizer implements Converter<any, any> {
  convert(source: any, target: any = {}): any {
    target = {
      ...source,
      url:source.url.includes("https") ? source.url : this.normalizeSlug(decodeURIComponent(source.url)),
    };
    return target;
  }


  protected reservedSlugCharacters = ` !*'();:@&=+$,?%#[]`;
  protected slugChar = '-';

  // created the regex only once
  private slugRegex = new RegExp(`[${this.reservedSlugCharacters.split('').join('\\')}]`, 'g');
  private sanitizeMultipleSlugChars = new RegExp(`${this.slugChar}+`, 'g');
  protected normalize(name: string): string {
    return name.replace(/<[^>]*>/g, '');
  }
  /**
   * Provides a title slug for the pretty URL.
   *
   * The name is sanitized from html, trimmed, converted to lowercase and special characters
   * which are encoded are replaced by the slug char (dash by default).
   */
  protected normalizeSlug(name: string): string {
    return this.normalize(name)
      .trim()
      .replace(this.slugRegex, this.slugChar)
      .replace(this.sanitizeMultipleSlugChars, this.slugChar);
  }

}
